import { InjectionToken } from "@angular/core";
import { AppSettingsUrl } from "../app/appSettings";
import { HashTable } from "./hash-table";

export interface IAmbassador {
    tittle: string;
    redirectUrl: string;
    domain: string;
    logoKey: string;
    shortLogoKey: string;
    email?: string;
    discord?: string;
    telegram?: string;
    planJson?: string;
}

export class AmbasadorKeeper {

    data: IAmbassador[] = [
        {
            domain: "marktools.pro",
            logoKey: "smc.png",
            shortLogoKey: "smc_bull.png",
            redirectUrl: '',
            tittle: "Smart Money Club",
            planJson: "smc_plans.json",
            telegram: "sma_manager"
        },
        {
            domain: "my.marktools.net",
            logoKey: null,
            shortLogoKey: "favicon.svg",
            redirectUrl: '',
            tittle: "I'm alone",
            planJson: null
        }
    ];

    constructor(private window: Window) {

        this.data.forEach(x => x.redirectUrl = `https://${x.domain}`);
    }

    hasCurrentAmbassador = (): boolean => !!this.getAmbassador();

    getAmbassador = (): IAmbassador => {
        let host = this.window.location.hostname;
        if (AppSettingsUrl.debug)
            host = 'marktools.pro';
        return this.data.find(s => s.domain == host);
    }

    getAll = (): IAmbassador[] => [...this.data];
}
